import store from "src/store";
import { getAndEraseCookie } from "src/util/CookieReciever";
import UserServices from "src/services/user/userServices"

async function AuthenticateAndLogin() {
    if(process.env.NODE_ENV === "production") {
        console.log("LoginProces::AuthenticateAndLogin::Running in Production")
        if(checkForSkipAuthentication()) {
            return true;
        }
        let loginCookie = getAndEraseCookie("username")
        let passCookie = getAndEraseCookie("password")
        let externalSSOUser = getAndEraseCookie("ssoUser")
        let ssoAccessToken = getAndEraseCookie("accessToken")
        // Check if user is an internal user and logged in through login.asp
        if (loginCookie && passCookie) {
            var authenticateResult = await authenticate(loginCookie, passCookie)
            var populateUserResult = await populateCurrentUser(loginCookie)
            if(authenticateResult && populateUserResult) {
                console.log("LoginProcess::AuthenticateAndLogin::User Logged In")
                return true
            }
            else {
                console.log('LoginProces::AuthenticateAndLogin::Could not login user using username and password')
                return false
            }
            
        }
        // Check if user is an external user and logged in through SSO
        if (externalSSOUser && ssoAccessToken) {
            //SSO token is JWT, no need to authenticate
            store.commit('currentUser/setAuthToken', ssoAccessToken)
            var populateUserResult = await populateCurrentUser(loginCookie)
            if(populateUserResult) {
                console.log("LoginProcess::AuthenticateAndLogin::External User Logged In")
                return true
            }
            else {
                console.log('LoginProces::AuthenticateAndLogin::Could not login user using SSO')
            }
            
        }
        // Check if user is already logged in
        if (store.state.currentUser.currentUser) {
            console.log("LoginProcess::AuthenticateAndLogin::User Already Logged In")
            return true
        }
        // Otherwise go back to login screen
        console.log("LoginProcess::AuthenticateAndLogin::User not in store and cannot find user cookies")
        return false

    } 
    else if (process.env.NODE_ENV == "development") {
        console.log('LoginProcess::AuthenticateAndLogin::Running in Development Mode')
        if(checkForSkipAuthentication()) {
            return true;
        }
        // Populate User
        var user
        try {
            var getUserResponse = await UserServices.getUser('eggersean@gmail.com')
            console.log('LoginProcess::Development::PopulateUser ', getUserResponse.result)
            user = getUserResponse.result
        } catch {
            console.log('LoginProcess::AuthenticateAndLogin::No connection to APIs found. Using Dev User')
            user = {
                login: 'DEV@DOMAIN.COM',
                first_name: 'DEV',
                last_name: 'USER',
                practice: 'setpointhealth.com',
            }
        }  
        // set practice here if you want to change the practice for development
        // user.practice = 'RAINIERMD.SPHPRO.COM'
        // set role here if change needed
        // user.role = "COACH"
        store.commit('currentUser/setUser', user)
        console.log("LoginProcess::AuthenticateAndLogin::Development User Logged In")
        return true
        
    }
}

async function populateCurrentUser(login) {
    try {
        var getUserResponse = await UserServices.getUser(login)
        var user = getUserResponse.result
        // if no user returned
        if(!user) {
            throw "No User Found"
        }
        if(!(window.location.hostname.includes('localhost'))){
            // Set Users Practice to be current domain in case user is super user
            user.practice = window.location.hostname           
        }
        store.commit('currentUser/setUser', user)
        console.log('LoginProcess::populateCurrentUser::User population successful::', user)
        return true        
       
    } catch (err) {
        console.log('LoginProcess::PopulateCurrentUser::Error Populating Current User::', err)
        return false
    }
}

async function authenticate(login, password) {
    try {
        var credentials = { username: login, password: password }
        var authToken = await UserServices.Authenticate(credentials)
        // If no auth token was returned
        if(!authToken) {
            throw "No Auth Token Recieved"
        }
        store.commit('currentUser/setAuthToken', authToken)
        console.log('LoginProcess::Authenticate::Authentication Successful')
        return true
    } catch (err) {
        console.log('LoginProcess::Authenticate::Athentication Unseccessful::', err)
        return false
    }
}

function checkForSkipAuthentication(currentPath) {
    var skipAuthenticateRoutes = [
        '/onboard',
        '/onboardQR',
        '/onboardqr',
        '/resourcecenter'
    ]
    var currentPath = window.location.hash.replace('#', '')
    console.log('LoginProcess::checkForSkipAuthentication::Checking for non authentication route.')
    if(skipAuthenticateRoutes.includes(currentPath)) { // if using the onboarding form/qr code dont authenticate
        console.log('LoginProcess::checkForSkipAuthentication::Onboard Detected. Skipping Authentication')
        return true
    }
    return false
}

export {
    AuthenticateAndLogin
}
